module.exports = __webpack_public_path__ + "static/media/Background-House_Open.e157f0c3.svg";